import { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const STORAGE_KEY = "cs_admin_token";

const AdminAuthContext = createContext({
  token: null,
  loading: true,
  login: async () => false,
  logout: () => {},
});

export function AdminAuthProvider({ children }) {
  const [token, setToken] = useState(() => localStorage.getItem(STORAGE_KEY));
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    if (!token) {
      setLoading(false);
      return () => {};
    }
    axios
      .get(`${API}/admin/me`, { headers: { Authorization: `Bearer ${token}` } })
      .then(() => active && setLoading(false))
      .catch((err) => {
        if (!active) return;
        const s = err?.response?.status;
        if (s === 401 || s === 403) {
          localStorage.removeItem(STORAGE_KEY);
          setToken(null);
        }
        setLoading(false);
      });
    return () => {
      active = false;
    };
  }, [token]);

  const login = async (password) => {
    const { data } = await axios.post(`${API}/admin/login`, { password });
    localStorage.setItem(STORAGE_KEY, data.token);
    setToken(data.token);
    return true;
  };

  const logout = () => {
    localStorage.removeItem(STORAGE_KEY);
    setToken(null);
  };

  return (
    <AdminAuthContext.Provider value={{ token, loading, login, logout }}>
      {children}
    </AdminAuthContext.Provider>
  );
}

export function useAdminAuth() {
  return useContext(AdminAuthContext);
}

export function adminHeaders(token) {
  return token ? { Authorization: `Bearer ${token}` } : {};
}
